import React from 'react';

export default function GithubLink() {
    return (
        <footer id='footer'>
            <a href='https://github.com/timdavidharris/book-shelf-react-app' target='_blank' rel="noopener noreferrer">
                Website Code (GitHub) Link Here
            </a>
        </footer>
    )
}
